import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Menu, Plus } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

const LINKS = [
  { to: "/marketplace", label: "Categorías (Scrap & Mermas)", id: "categorias" },
  { to: "/perfiles/generadoras", label: "Empresas Generadoras", id: "generadoras" },
  { to: "/perfiles/gestoras", label: "Empresas Gestoras", id: "gestoras" },
  { to: "/perfiles/transporte", label: "Empresas Transporte", id: "transporte" },
  { to: "/calculadora", label: "Calculadoras ESG", id: "calculadora" },
];

const linkCls = ({ isActive }) =>
  `text-[13px] font-medium transition-colors duration-200 ${isActive ? "text-[#00f2a1]" : "text-slate-300 hover:text-white"}`;

const Actions = ({ onClick, mobile = false }) => {
  const navigate = useNavigate();
  return (
    <div className={`flex ${mobile ? "flex-col items-stretch" : "items-center"} gap-2 2xl:gap-3`}>
      <Button data-testid={mobile ? "mobile-button-publish" : "nav-button-publish"} onClick={() => { onClick?.(); navigate("/publicar"); }}
        className="rounded-full font-semibold hover:bg-[#00d890] hover:shadow-[0_0_22px_rgba(0,242,161,0.45)] transition-[background-color,box-shadow] duration-300">
        <Plus className="w-4 h-4" /> Publicar Lote
      </Button>
      <Show when="signed-out">
        <Button variant="outline" data-testid={mobile ? "mobile-button-login" : "nav-button-login"} onClick={() => { onClick?.(); navigate("/sign-in"); }}
          className="rounded-full bg-transparent border-[#1b3d30] text-slate-200 hover:bg-[#122a21] hover:text-white">
          {mobile ? "Iniciar Sesión / Registro" : <><span className="2xl:hidden">Ingresar</span><span className="hidden 2xl:inline">Iniciar Sesión / Registro</span></>}
        </Button>
      </Show>
      <Show when="signed-in">
        <Link to="/panel" onClick={onClick} data-testid={mobile ? "mobile-link-dashboard" : "nav-link-dashboard"} className="text-sm text-slate-300 hover:text-[#00f2a1] transition-colors">Mi panel</Link>
        <div data-testid="nav-user-button"><UserButton /></div>
      </Show>
    </div>
  );
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-[#0a1f18]/90 backdrop-blur-md border-b border-[#1b3d30]" data-testid="site-header">
      <div className="max-w-[1680px] mx-auto px-5 lg:px-8 h-16 flex items-center justify-between gap-4 2xl:gap-6">
        <Logo className="shrink-0 whitespace-nowrap" />
        <nav className="hidden xl:flex items-center gap-4 2xl:gap-6 whitespace-nowrap" aria-label="Principal">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} className={linkCls} data-testid={`nav-link-${l.id}`}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="hidden xl:block shrink-0"><Actions /></div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="xl:hidden text-slate-200 p-2" aria-label="Abrir menú" data-testid="mobile-menu-button"><Menu /></button>
          </SheetTrigger>
          <SheetContent className="bg-[#0a1f18] border-[#1b3d30] text-white" data-testid="mobile-menu">
            <SheetTitle className="text-white mb-6"><Logo testId="mobile-menu-logo" /></SheetTitle>
            <nav className="flex flex-col gap-5 mb-8">
              {LINKS.map((l) => (
                <NavLink key={l.id} to={l.to} onClick={() => setOpen(false)} className={linkCls} data-testid={`mobile-link-${l.id}`}>{l.label}</NavLink>
              ))}
            </nav>
            <Actions mobile onClick={() => setOpen(false)} />
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
